import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '@ohif/ui';

// Route Components
import DataSourceWrapper from './DataSourceWrapper';
import WorkList from './WorkList';
import Local from './Local';
//import Debug from './Debug';
//import NotFound from './NotFound';
import buildModeRoutes from './buildModeRoutes';
import PrivateRoute from './PrivateRoute';

//console.log('platform/viewer/src/routes/index.tsx');

// TODO: Include "routes" debug route if dev build

/* const bakedInRoutes = [
  {
    path: '/debug',
    children: Debug,
  },
  {
    path: '/local',
    children: Local,
  },
]; */

// NOT FOUND (404)
//const notFoundRoute = { component: NotFound };
const WorkListRoute = {
  path: '/worklist',
  children: DataSourceWrapper, //Local, //DataSourceWrapper,  // ha itt Local van a props-nál meg WorkList, akkor dropzone lesz, ha itt DatasourceWrapper, propsnál worklist akkor dicomweb
  // private: true,
  props: { children: WorkList }, //Local}, //, WorkList },
};

const DropZoneRoute = {
  path: '/',
  children: Local, //DataSourceWrapper, //Local, //DataSourceWrapper,  // ha itt Local van a props-nál meg WorkList, akkor dropzone lesz, ha itt DatasourceWrapper, propsnál worklist akkor dicomweb
  // private: true,
  props: { children: Local}, //, WorkList },
};


const createRoutes = ({
  modes,
  dataSources,
  extensionManager,
  servicesManager,
  commandsManager,
  hotkeysManager,
  routerBasename,
  showStudyList,
}) => {
  const routes =
    buildModeRoutes({
      modes,
      dataSources,
      extensionManager,
      servicesManager,
      commandsManager,
      hotkeysManager,
    }) || [];


/*   const { customizationService } = servicesManager.services;

  const customRoutes = customizationService.getGlobalCustomization(
    'customRoutes'
  ); */
  const allRoutes = [
    ...routes,
    DropZoneRoute,
    WorkListRoute,
  ];

  // console.log('all routes = ', allRoutes);

  function RouteWithErrorBoundary({ route, ...rest }) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (
      <ErrorBoundary context={`Route ${route.path}`} fallbackRoute="/">
        <route.children
          {...rest}
          {...route.props}
          route={route}
          servicesManager={servicesManager}
          extensionManager={extensionManager}
          hotkeysManager={hotkeysManager}
        />
      </ErrorBoundary>
    );
  }

  const { userAuthenticationService } = servicesManager.services;

  // Note: PrivateRoutes in react-router-dom 6.x should be defined within
  // a Route element
  return (
    <Routes>
      {allRoutes.map((route, i) => {
        return route.private === true ? (
          <Route
            key={i}
            exact
            path={route.path}
            element={
              <PrivateRoute
                handleUnauthenticated={
                  userAuthenticationService.handleUnauthenticated
                }
              >
                <RouteWithErrorBoundary route={route} />
              </PrivateRoute>
            }
          ></Route>
        ) : (
          <Route
            key={i}
            path={route.path}
            element={<RouteWithErrorBoundary route={route} />}
          />
        );
      })}
    </Routes>
  );
};

export default createRoutes;
